import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Mail, Phone, MapPin } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const contactInfo = [
    {
      icon: <Mail size={28} />,
      label: 'Email',
      value: 'contact@danstonai.com',
      link: 'mailto:contact@danstonai.com',
    },
    {
      icon: <Phone size={28} />,
      label: 'Phone',
      value: '+91 9259000200',
      link: 'tel:+919259000200',
    },
    {
      icon: <MapPin size={28} />,
      label: 'Our Reach',
      value: 'Global AI Solutions Provider',
      link: null,
    },
  ];

  return (
    <section className="contact-section" id="contact" ref={ref} data-testid="contact-section">
      <div className="container">
        <motion.div
          className="contact-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title-white" data-testid="contact-title">
            Get In Touch
          </h2>
          <p className="section-subtitle-white" data-testid="contact-subtitle">
            Ready to transform your business with AI? Contact us today.
          </p>
        </motion.div>

        <div className="contact-grid">
          {contactInfo.map((info, index) => (
            <motion.div
              key={index}
              className="contact-card glass-card"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.15, duration: 0.5, ease: 'easeOut' }}
              data-testid={`contact-${index}`}
            >
              <div className="contact-icon">{info.icon}</div>
              <h3 className="contact-label">{info.label}</h3>
              {info.link ? (
                <a href={info.link} className="contact-value" data-testid={`contact-link-${index}`}>
                  {info.value}
                </a>
              ) : (
                <p className="contact-value">{info.value}</p>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
